import { h } from 'preact'

function stripHtml(html) {
  if (!html) return ''
  return html.replace(/<[^>]*>/g, '').trim()
}

export function BlogCardFeatured({ blog, url }) {
  if (!blog) return null

  const plainTextExcerpt = stripHtml(blog.summary_html || '')
  const truncatedExcerpt = plainTextExcerpt.length > 200
    ? plainTextExcerpt.substring(0, 200) + '...'
    : plainTextExcerpt

  return (
    <div className="col-span-full md-max:flex md-max:flex-col-reverse md-max:items-start md-max:justify-start grid grid-cols-2 items-center justify-center w-full-margin -ml-margin h-fit">
      <div
        className="grow flex flex-col items-center justify-between gap-1.5 relative w-full h-full px-margin py-2.5 md:px-7.5 py-3.5 bg-[--bg-colour]"
        style={{ '--bg-colour': '#cf4b2c' }}
      >
        <div className="flex flex-col items-start justify-start gap-0.25 w-full h-fit">
          <div
            className="w-full text-center text-[--text-colour] richtext paragraph-s"
            style={{ '--text-colour': '#ffffff' }}>
            <h2><strong>Featured</strong></h2>
          </div>
        </div>

        <div
          data-block-id="AbFJSRERtTGYyeDJsQ__layout_iFt4Cn"
          className="flex items-center justify-center flex-col gap-1.25 md:gap-1.75 w-full h-fit"
        >
          <div
            className="w-full text-center text-[--text-colour] richtext h3"
            style={{ '--text-colour': '#ffffff' }}
          >
            <h3><strong>{blog.title}</strong></h3>
          </div>

          <div
            className="w-full text-center text-[--text-colour] richtext paragraph-m"
            style={{ '--text-colour': '#ffffff' }}
          >
            {truncatedExcerpt}
          </div>
        </div>

        <div className="flex items-center justify-center flex-row gap-0.25 w-full h-fit">
          <a
            href={url}
            className="btn btn-m btn-secondary btn-fill w-fit"
            aria-label="Read More"
          >
            <span>Read More</span>
          </a>
        </div>
      </div>

      <div className="flex items-start justify-start flex-col gap-0.25 w-full grow">
        <div
          className="w-full h-full bg-[--bg-colour] aspect-4/3 md:aspect-1/1 overflow-hidden"
          style={{ '--bg-colour': '#737373' }}
        >
          <div className="size-full children:size-full children:object-cover">
            {blog.image?.src && (
              <img
                src={blog.image.src}
                alt={blog.image.alt || blog.title}
                className="size-full object-cover"
                loading="lazy"
                width={blog.image.width}
                height={blog.image.height}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
